import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgMegaphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#3A3247",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 3.832v4.706c1.173.089 2 1.119 2 2.243s-.827 2.155-2 2.244v4.542l-1.404-.62a30 30 0 0 0-3.624-1.286 23 23 0 0 0-2.477-.574l1.51 5.113H9.322l-1.687-5.381C5.62 14.445 4 12.806 4 10.699c0-2.405 2.11-4.2 4.512-4.2 1.323 0 2.938-.326 4.46-.761a30 30 0 0 0 3.624-1.287zm0 6.95v.021-.044zM13.522 7.66c-1.588.454-3.411.838-5.009.838C7.035 8.5 6 9.57 6 10.7s1.035 2.2 2.512 2.2c1.598 0 3.42.385 5.01.839a34 34 0 0 1 2.478.815V6.846c-.722.269-1.574.556-2.479.815Z",
  clipRule: "evenodd"
})));

export { SvgMegaphone as ReactComponent };
//# sourceMappingURL=Megaphone.svg.js.map
